package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
enum class Language(val level: Level) {
    FRENCH(level = Level.BEGINNER),
    ENGLISH(level = Level.BEGINNER),
    CHINESE(level = Level.BEGINNER),
    SPANISH(level = Level.BEGINNER),
    ARABIC(level = Level.BEGINNER),
    GERMAN(level = Level.BEGINNER),
    RUSSIAN(level = Level.BEGINNER),
}